<template>
  <div ref="modal" class="modal fade" tabindex="-1" role="form">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-body">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
          <div class="container text-center">
            <h1>{{ title }}</h1>
            <p>{{ copy }}</p>
          </div>
          <form ref="form" :action="formAction" method="post" @submit="checkForm">
            <input type="hidden" id="score" name="score" value="0.0"/>
            <div class="container">
              <template v-if="!complete">
                <div class="alert alert-danger fade show" v-if="formError" v-cloak>
                  An error occurred while submitting the form. Please check all fields and try again.
                </div>
                <div class="alert alert-danger fade show" role="alert" v-if="requiredError" v-cloak>
                  <b>Please enter your information for all required fields.</b>
                </div>
                <div class="alert alert-danger fade show" role="alert" v-if="recaptchaError" v-cloak>
                  <b>Failed to submit form. Please try again.</b>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <input type="text" placeholder="First Name *"
                           v-model="firstName" :class="{'has-error': firstNameError}"/>
                  </div>
                  <div class="col-md-6">
                    <input type="text" placeholder="Last Name *"
                           v-model="lastName" :class="{'has-error': lastNameError}"/>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <input type="email" placeholder="Enter Email Address *"
                           v-model="email" :class="{'has-error': emailError}"/>
                    <input name="tracer" type="text" placeholder="Contact Tracer *" class="tracer"/>
                  </div>
                  <div class="col-md-6">
                    <input type="text" placeholder="School ZIP code"
                           v-model="zip"/>
                  </div>
                </div>
              </template>
              <div class="text-center">
                <button v-if="complete" class="btn btn-default bg-orange white" data-dismiss="modal">CLOSE WINDOW
                </button>
                <button v-else type="submit" class="btn btn-default bg-orange white">
                  <template v-if="sending"><i class="fas fa-circle-notch fa-spin"></i> SIGNING YOU UP!</template>
                  <template v-else>SIGN ME UP!</template>
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "newsletter",
  props: {
    recaptchaKey: String
  },
  data() {
    return {
      formAction: "/forms/l/263392/2018-09-22/9dngq",
      firstName: "",
      lastName: "",
      email: "",
      zip: "",
      submitted: false,
      formError: false,
      requiredError: false,
      recaptchaError: false,
      sending: false,
      complete: false
    }
  },
  computed: {
    title() {
      if (this.complete) {
        return "You're Signed-up!";
      } else {
        return "Email Sign-Up";
      }
    },
    copy() {
      if (this.complete) {
        return "You'll be the first to know when we release a new report.";
      } else {
        return "Be the first to know when we release new reports, resources, and guidance on how to select quality instructional materials for your community.";
      }
    },
    firstNameError() {
      return this.submitted && !this.firstName;
    },
    lastNameError() {
      return this.submitted && !this.lastName;
    },
    emailError() {
      let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return this.submitted && !re.test(String(this.email).toLowerCase());
    }
  },
  methods: {
    open: function() {
      $(this.$refs.modal).modal('show');
    },
    close: function() {
      $(this.$refs.modal).modal('hide');
    },
    checkForm(event) {

      event.preventDefault();

      this.formError = false;
      this.submitted = true;

      if (this.emailError || this.firstNameError || this.lastNameError) {
        this.requiredError = true;
      } else {
        this.requiredError = false;
        this.submitForm(event);
      }
    },
    submitForm(event) {

      this.sending = true;
      let vue = this;

      this.recaptchaError = false;
      reCAPTCHA(function(response) {
        if (response.success) {
          if (0.5 < response.score) {
            $.ajax({
              url: vue.formAction,
              type: "POST",
              data: {
                fname: encodeURIComponent(vue.firstName),
                lname: encodeURIComponent(vue.lastName),
                email: vue.email,
                zip: encodeURIComponent(vue.zip),
                tracer: vue.tracer,
                score: response.score
              },
              complete: function(response) {
                vue.completeForm(JSON.parse(response.responseText));
              }
            });
          } else {
            vue.notifications = false;
            vue.completeForm({status: "success"});
          }
        } else {
          vue.sending = false;
          $('#recaptcha-error').show();
        }
      });
    },
    completeForm: function(response) {
      this.sending = false;
      if (response.status == "success") {
        this.complete = true;
      } else {
        this.formError = true;
      }
    }
  }
}
</script>
<style scoped>

.modal-body {
  padding: 3rem 1rem;
}

button.close {
  position: absolute;
  top: 0.2em;
  right: 0.5em;
  font-size: 1.8em;
}

p {
  font-size: 1.8em;
  margin-bottom: 1em;
}

.row > div {
  padding-left: 1em;
  padding-right: 1em;
}

form {
  margin: 0 auto;
}

form input {
  color: #084565;
  font-size: 1.2em;
  font-weight: normal;
  line-height: 1.5em;
  width: 100%;
  height: 2em;
  border: 3px solid #084565;
  margin-bottom: 1.5em;
}

form input.has-error {
  border: 3px solid #721c24;
  color: #721c24;
}

form button {
  font-size: 1.2em;
  height: 2em;
  line-height: 1.5em;
  width: 340px;
  max-width: 100%;
}

form button:hover {
  color: #084565 !important;
  background-color: #fff !important;
  border: 3px solid #084565 !important;
}

form button i {
  margin-left: 0.25em;
}

[v-cloak] {
  display: none;
}

</style>